var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Live = OCS.Viewer.Live || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Interfaces = OCS.Viewer.Interfaces || {};
OCS.Viewer.Functions = OCS.Viewer.Functions || {};

//TODO: Continue work on developing this idea out of having a data store interface to work with the storage manager 
// Required: OCS.Viewer.Classes.DataMngrDataRequest

OCS.Viewer.Functions.define_data_store_class = function () {
    OCS.Viewer.Classes.DataStore = new Class({
        Implements: [Options, Events, new Class(OCS.Viewer.Interfaces.DataStore)],
        options: {
            debug: false,
            store_locally: true
        },
        destroy: function () {

        }
    });

};
OCS.Viewer.Functions.define_data_store_class();